import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AppService} from '../app.service';
import {ApiService} from '../api.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';

@Injectable()
export class AuthUserGuardService implements CanActivate, CanActivateChild {

  constructor(private appService: AppService,
              private apiHttpService: ApiService,
              private router: Router) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

    if (this.appService.getAuthUser() && this.appService.getAuthUser().id) {
      return true;
    } else {
      return this.apiHttpService.userAuthenticate()
        .switchMap(
          (response: any) => Observable.forkJoin([
            this.getAuthUserRoles(response.data.userId),
          ]))
        .map((result) => {
          if (result[0] && result[0].value) {
            this.appService.setAuthUser(result[0].value);
          } else {
            this.router.navigate(['/server-error']);
            return false;
          }
          return true;
        }).catch((error) => {
          this.appService.logoutUser();
          this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
          return Observable.of(false);
        });
    }
  }

  getAuthUserRoles(userId): Observable<any> {
    return this.apiHttpService.getAuthUserRoles(userId).map((resp: any) => {
      return Observable.of(resp.data);
    }).catch((error) => {
      return Observable.of([]);
    });
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/services/guards/auth-user-guard.service.ts